<template>
  <div class="practiceAreas">
    <div class="section is-medium">
      <div class="container is-fluid">
        <div class="columns">
          <div class="column is-one-quarter">
            <h1 class="deneme">PRACTICE AREAS</h1>
          </div>
          <!-- <div class="column tile iceriks">
                <ul class="tile is-parent is-vertical">
                    <li class="tile is-child">Information Technology, E-Commerce, Domain Names and Telecommunication</li>
                    <li class="tile is-child">Litigation and Commercial Disputes</li>
                    <li class="tile is-child">Maritime and Transportation</li>
                    <li class="tile is-child">Intellectual Property Law</li>
                    <li class="tile is-child">Real Property and Construction Law</li>
                    <li class="tile is-child">Customs and Ports Law</li>
                    <li class="tile is-child">Aviation Law</li>
                    <li class="tile is-child">Permits, Licences and Authorization</li>
                    <li class="tile is-child">Data Privacy</li>
                    <li class="tile is-child">Media, Entertainment and Fashion</li>
                    <li class="tile is-child">Start-Ups and International Investments</li>
                    <li class="tile is-child">Contracts Law</li>
                    <li class="tile is-child">Sports Law</li>
                    <li class="tile is-child">Work and Residence Permits</li>
                </ul>
             
            </div> -->
          <div class="tile is-ancestor">
            <span class="plusActive"></span>
            <div class="tile is-vertical is-12">
              <div class="tile">
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification ">
                    <ul class="tile is-parent is-vertical">
                      <li>Intellectual Property</li>
                      <li>Information Technology and E-Commerce</li>
                      <li>Domain Names and Telecommunication</li>
                      <li>Data Privacy</li>
                    </ul>
                  </article>
                </div>
                <div class="tile is-parent">
                  <article class="tile is-child notification">
                    <ul class="has-text-right is-parent is-vertical tile">
                      <li>Maritime and Transportation</li>
                      <li>Aviation Law</li>
                      <li>Customs and Ports</li>
                      <li>Work and Residence Permits</li>
                    </ul>
                  </article>
                </div>
              </div>
              <div class="tile">
                <div class="tile is-parent is-vertical">
                  <article class="tile is-child notification">
                    <ul class="has-text-left is-parent is-vertical tile">
                      <li>Litigation and Commercial Disputes</li>
                      <li>Contracts Law</li>
                      <li>Real Property</li>
                      <li>Construction Law</li>
                    </ul>
                  </article>
                </div>
                <div class="tile is-parent">
                  <article class="tile is-child notification">
                    <ul class="has-text-right is-parent is-vertical tile">
                      <li>Start-Ups and International Investments</li>
                      <li>Permits, Licences and Authorization</li>
                      <li>Media, Entertainment and Fashion</li>
                      <li>Sports Law</li>
                    </ul>
                  </article>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'practiceAreas',
  data() {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.practiceAreas p {
  font-size: 1.5rem;
}

#app {
  background: #606c96;
}

.practiceAreas h1::after {
  content: "";
  position: absolute;
  height: 5px;
  bottom: 0;
  left: 0;
  width: 40%;
  background: #81A716;
}

.practiceAreas h1 {
  position: relative;
  color: #504f50;
}

.iceriks {
  background: url(/static/sarikayaPlus.svg) no-repeat center center;
}

.tile.is-parent ul {
  display: flex;
  justify-content: center;
}

.tile.is-parent {
  min-height: 230px;
}

.plusActive {
  background: #81a716;
  height: 200px;
  width: 200px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: -1;
}

.tile.is-ancestor:last-child {
  position: relative;
}

ul.tile.is-parent.is-vertical {
  font-size: 1.3rem;
}


@media only screen and (max-width: 768px) {
  .practiceAreas {
    margin-bottom: 100px;
  }
  .practiceAreas h1 {
    font-size: 25px;
  }
    div.column.is-one-quarter::after {
    content: "";
    position: absolute;
    right: 12%;
    top: 0;
    height: 100%;
    background:unset;
    width: 1px;
  }
  ul li {
    text-align: left;
  }
  .plusActive {
    display: none;
  }
  .tile.is-parent {
    padding: 0px;
    min-height: 90px;
}
}
</style>



// WEBPACK FOOTER //
// practice-areas.vue?3501c1df